export default __webpack_public_path__ + "static/media/keto_skipped_breakfast@3x.00fca75e.jpg";